/* eslint-disable @typescript-eslint/member-ordering */
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { NotificationIcon } from '../../../icons/notification-icon/notification-icon';
import { NgClass } from '@angular/common';
import { CloseIconComponent } from '../../../icons/close-icon/close-icon.component';
import { ImportCompletedNotificationsService } from '../../../../../services/import-completed-notifications-service';
import { AgentActionDirective } from '../../../../directives/agent-action.directive';

@Component({
  selector: 'app-notification-dropdown',
  imports: [NotificationIcon, NgClass, CloseIconComponent, AgentActionDirective],
  templateUrl: './notification-dropdown.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './notification-dropdown.scss',
})
export class NotificationDropdown {
  private readonly notificationService = inject(ImportCompletedNotificationsService);

  protected notifications = this.notificationService.receivedNotification;
  protected isDropdownOpen = false;

  protected toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  protected removeNotification(notificationId: string): void {
    this.notificationService.removeImportCompletedNotification(notificationId);
    if (this.notifications().length === 0) {
      this.isDropdownOpen = false;
    }
  }
}
